"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _styled = _interopRequireDefault(require("@emotion/styled"));
var _reactTracking = require("react-tracking");
var _checkedBox = _interopRequireDefault(require("./checked-box"));
var _uncheckedBox = _interopRequireDefault(require("./unchecked-box"));
var _languageDirectionAPI = require("../../../services/languageDirectionAPI");
var _mediaQuery = _interopRequireDefault(require("../../../styles/media-query"));
const StyledCheckboxWrapper = _styled.default.div({
  display: 'flex'
});
const StyledCheckbox = _styled.default.input(_ref => {
  var _theme$colors, _theme$colors2;
  let {
    direction,
    theme
  } = _ref;
  return (0, _mediaQuery.default)({
    appearance: 'none',
    cursor: 'pointer',
    '&:not(:checked)': {
      '&::after': {
        appearance: 'auto',
        content: `url("data:image/svg+xml; utf8, ${(0, _uncheckedBox.default)(theme === null || theme === void 0 ? void 0 : (_theme$colors = theme.colors) === null || _theme$colors === void 0 ? void 0 : _theme$colors.textPrimary)}")`,
        display: 'block',
        width: '24px'
      }
    },
    '&:checked': {
      '&::after': {
        appearance: 'auto',
        content: `url("data:image/svg+xml; utf8, ${(0, _checkedBox.default)(theme === null || theme === void 0 ? void 0 : (_theme$colors2 = theme.colors) === null || _theme$colors2 === void 0 ? void 0 : _theme$colors2.textPrimary)}")`,
        display: 'block',
        width: '24px'
      }
    },
    // Note that the margin may look a little wide in devtools mobile view, but it's correct on an actual phone.
    [direction === 'ltr' ? 'marginRight' : 'marginLeft']: ['10px', '4px', '4px', '4px'],
    [direction === 'ltr' ? 'marginLeft' : 'marginRight']: '0px',
    marginTop: '-2px'
  });
});
const StyledDescription = _styled.default.label(_ref2 => {
  let {
    theme
  } = _ref2;
  return {
    fontSize: theme.fontSizes.xxSmall,
    '&:hover': {
      cursor: 'pointer'
    }
  };
});

/**
 * Simple checkbox with a description that allows for prechecking.
 */
const Checkbox = /*#__PURE__*/(0, _react.forwardRef)((_ref3, ref) => {
  let {
    children,
    id,
    name,
    register
  } = _ref3;
  const {
    trackEvent
  } = (0, _reactTracking.useTracking)();
  const {
    direction
  } = (0, _languageDirectionAPI.useLanguageDirection)();
  const handleToggleChecked = _ref4 => {
    let {
      target: {
        checked
      }
    } = _ref4;
    trackEvent({
      event_name: name,
      event_type: checked ? 'checked' : 'unchecked'
    });
  };
  const registerParams = componentId => ({
    ...register(componentId)
  });
  return /*#__PURE__*/_react.default.createElement(StyledCheckboxWrapper, null, /*#__PURE__*/_react.default.createElement(StyledCheckbox, Object.assign({
    direction: direction,
    id: id,
    name: name,
    ref: ref,
    type: "checkbox",
    onChange: handleToggleChecked
  }, registerParams(id))), /*#__PURE__*/_react.default.createElement(StyledDescription, {
    htmlFor: id
  }, children));
});
Checkbox.displayName = 'Checkbox';
var _default = exports.default = Checkbox;